import { DecimalPipe } from "@angular/common";

export class executionInterval{

    public start_date: string;
    public interval: string;
    public end_date: string;
}